import styled from 'styled-components';


export const SearchBorder= styled.div
.attrs(() => ({
  className: 'white mt-25',
}))`
border-radius: 5px !important;
padding: 0.1em 0.0em 0.1em 0.3em  !important;
max-width:98%;
border: 1px solid var(--grey, #D9D9D9) !important;
`;


export const GuestListTableContainer= styled.div
.attrs(() => ({
  className: 'white mt-25',
}))`
    border-radius: 10px;
    background: #FFF;
    width:100%;
    padding:16px 18px;
`;




export const FieldBtn  = styled.button
.attrs(() => ({
  className: 'btn-flat center btn large  w-100',
}))`
border-radius: 5px;
background: #fff !important;
// width:80% !important;
// width:178px !important;
height:46px !important;
font-size: 13px;
font-family: Plus Jakarta Sans !important;
font-style: normal;
font-weight: 600;
text-transform: capitalize !important;
color: #4F46E5;
border: 1px solid var(--primary-indigo, #4F46E5);

:hover{
color: var(--white, #FFF);
background: var(--primary-indigo, #4F46E5) !important;
}

`;


export const FieldBtnDelete  = styled.button
.attrs(() => ({
  className: 'btn-flat center btn large  w-100',
}))`
border-radius: 5px;
background: #e53935 !important;
// width:80% !important;
// width:178px !important;
height:46px !important;
font-size: 13px;
font-family: Plus Jakarta Sans !important;
font-style: normal;
font-weight: 600;
text-transform: capitalize !important;
color: #fff;
border: 1px solid var(--primary-indigo, #e53935);

// :hover{
// color: var(--white, #FFF);
// background: var(--primary-indigo, #e53935) !important;
// }

`;


export const FieldBtnDanger  = styled.button
.attrs(() => ({
  className: 'btn-flat center btn large  w-100',
}))`
border-radius: 5px;
background: transparent !important;
// width:80% !important;
// width:178px !important;
height:46px !important;
font-size: 13px;
font-family: Plus Jakarta Sans !important;
font-style: normal;
font-weight: 600;
text-transform: capitalize !important;
color: #e53935;
border: 1px solid var(--primary-indigo, #e53935);

:hover{
color: var(--white, #FFF);
background: var(--primary-indigo, #e53935) !important;
}

`;

export const FieldBtnSubmit  = styled.button
.attrs(() => ({
  className: 'btn-flat center btn large  w-100',
}))`
border-radius: 5px;
background: var(--primary-indigo, #4F46E5) !important;
// width:80% !important;
width:178px !important;
height:46px !important;
color: var(--white, #FFF);
font-size: 13px;
font-family: Plus Jakarta Sans !important;
font-style: normal;
font-weight: 600;
text-transform: capitalize !important;

`;



export const AnalyticsDuesTabs= styled.div
.attrs(() => ({
  className: 'white mt-25',
}))`
    width: 284px ;
    // flex:1;
    min-height: 91px;
    background: #FFFFFF;
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.03);
    border-radius: 10px;
    margin-right:20px;
    padding:8px 16px;
    h5{
      color: #71717A;
      font-family: Plus Jakarta Sans;
      font-size: 13px !important;
      font-style: normal;
      font-weight: 500;
      text-transform: uppercase;
    }
    .value{ 
      font-family: 'Plus Jakarta Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 21px;
      color: #18181B;
    }
    h6{
        font-family: 'Plus Jakarta Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        // color: #22C55E;
    }
    // @media only screen and (max-width: 600px) {
    @media only screen and (max-width: 992px) {
      // styles for medium screens and down
      width: 100% !important;
      margin:16px;
      // background: red;
    }
   
`;




